import {
  REQUEST_CLIENTS_TOTAL,
  REQUEST_CLIENTS_TOTAL_SUCCESS,
  REQUEST_CLIENTS_TOTAL_FAILURE,
  CLIENT_ENCODED_DATA_REQUEST,
  CLIENT_ENCODED_DATA_SUCCESS,
  CLIENT_ENCODED_DATA_FAILURE,
} from './types';

export const clientsTotalRequest = (entityId) => ({
  type: REQUEST_CLIENTS_TOTAL,
  entityId,
});

export const clientsTotalSuccess = (response) => ({
  type: REQUEST_CLIENTS_TOTAL_SUCCESS,
  response,
});

export const clientsTotalFailure = (error) => ({
  type: REQUEST_CLIENTS_TOTAL_FAILURE,
  error,
});

export const clientEncodedDataRequest = (entityId, payload, promise) => ({
  type: CLIENT_ENCODED_DATA_REQUEST,
  payload,
  entityId,
  promise,
});

export const clientEncodedDataSuccess = (response) => ({
  type: CLIENT_ENCODED_DATA_SUCCESS,
  response,
});

export const clientEncodedDataFailure = (error) => ({
  type: CLIENT_ENCODED_DATA_FAILURE,
  error,
});
